module.exports = __webpack_public_path__ + "img/CustodyExpenses.b44f48bc.svg";